import { render, staticRenderFns } from "./Ebooks.vue?vue&type=template&id=71b38058"
import script from "./Ebooks.vue?vue&type=script&lang=js"
export * from "./Ebooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports